import { GUEST_RESOURCE, GUEST_TOKEN, GUEST_PARAM_JSON } from "../../..";
export function isGuest(): boolean {
    if (GUEST_TOKEN && GUEST_RESOURCE)
        return true
    return false;
}
export function GetGuestParam(): any {
    if (GUEST_PARAM_JSON) {
        const tmp = decodeURIComponent(GUEST_PARAM_JSON)
        return JSON.parse(tmp!)
    }
    return undefined
}
export function GetGuestContactId() {
    const param = GetGuestParam()
    if (param) {
        return param.contactId
    }
    // console.log(param)
    return 0
}